import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("pmh_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const API_BASE = api.defaults.baseURL;

export const photoUrl = (p) => (!p ? "" : p.startsWith("http") ? p : `${API_BASE}/files/${p}`);

export default api;
